import React from "react";

const HTMLAlfa = () => <span data-component="alfa" />;

export default HTMLAlfa;
